{
  "DATA_ASSISTANT": {
    "TITLE": "Assistente de Dados",
    "NEW_CONVERSATION": "+ Nova",
    "LOADING": "A carregar...",
    "LOADING_MESSAGES": "A carregar mensagens...",
    "THINKING": "A pensar...",
    "UNTITLED": "Conversa sem título",
    "NO_CONVERSATIONS": "Ainda não há conversas. Clique em \"+ Nova\" para começar.",
    "EMPTY_STATE": "Selecione uma conversa ou crie uma nova para começar.",
    "PLACEHOLDER": "O que posso descobrir para si?",
    "SHOW_SQL": "Mostrar SQL",
    "NO_ROWS": "Nenhuma linha devolvida.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Excluir conversa",
    "DELETE_CONFIRM_DESCRIPTION": "Tem a certeza que pretende excluir esta conversa? Esta ação não pode ser revertida.",
    "DELETE_CONFIRM_YES": "Excluir",
    "REPORTS": "Relatórios",
    "SAVE_TO_REPORT": "Guardar no relatório",
    "NEW_REPORT": "Novo relatório",
    "REPORT_NAME": "Nome do relatório",
    "NO_REPORTS": "Ainda não há relatórios guardados",
    "REPORTS_EMPTY_STATE": "Selecione um relatório ou crie um novo.",
    "REPORT_SAVED": "Guardado no relatório",
    "DELETE_REPORT_CONFIRM": "Excluir relatório",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Tem a certeza que pretende excluir este relatório? Todos os itens guardados serão removidos.",
    "DELETE_ITEM_CONFIRM": "Remover item",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Tem a certeza que pretende remover este item do relatório?",
    "EXPORT_CSV": "Exportar CSV",
    "REFRESH": "Atualizar",
    "QUERY_RUNNING": "A executar consulta...",
    "QUERY_FAILED": "Falha na consulta",
    "AUTO_REFRESH": "Atualização automática",
    "AUTO_REFRESH_NONE": "Manual",
    "AUTO_REFRESH_30S": "30 segundos",
    "AUTO_REFRESH_1M": "1 minuto",
    "AUTO_REFRESH_5M": "5 minutos",
    "AUTO_REFRESH_10M": "10 minutos",
    "EDIT_MESSAGE": "Editar mensagem",
    "RENAME_REPORT": "Renomear relatório",
    "RENAME_ITEM": "Renomear item",
    "MOVE_UP": "Mover para cima",
    "MOVE_DOWN": "Mover para baixo",
    "COLLABORATORS": {
      "BUTTON": "Colaboradores",
      "TITLE": "Colaboradores do relatório",
      "DESCRIPTION": "Escolha quais os agentes e equipas que podem ver este relatório.",
      "AGENTS": "Agentes",
      "TEAMS": "Equipas",
      "SELECT_AGENTS": "Selecionar agentes",
      "SELECT_TEAMS": "Selecionar equipas",
      "SAVE": "Guardar",
      "SAVED": "Colaboradores atualizados",
      "SAVE_FAILED": "Não foi possível atualizar os colaboradores"
    }
  }
}
